import { QualifyingQuestions } from './qualifying-questions';
import {
  ApplicantQualifyingQuestionsContainerEntitiesDocument,
  ApplicantQualifyingQuestionsContainerApplicantUserUpdateDocument,
  ApplicantQualifyingQuestionsContainerApplicantUserFieldsFragment,
  ApplicantQualifyingQuestionsContainerEntityFieldsFragment,
  ApplicantQualifyingQuestionsContainerApplicantUserCurrentDocument
} from '../../../../generated';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { useMutation, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { lookupHealthProfessionQuery } from './qualifying-questions-health-profession-query';
import React from 'react';
import { App } from 'antd';

export const QualifyingQuestionsContainer: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();

  const { data: entities, loading: entitiesLoading, error: entitiesError } = useQuery(ApplicantQualifyingQuestionsContainerEntitiesDocument, {
    context: {
      headers: {
        "cache-enabled": "true"
      }
    }
  });

  const { data: healthData, error: healthProfessionError } = useQuery(lookupHealthProfessionQuery);

  const {
    data: qualifyingQuestionsData,
    loading: qualifyingQuestionsLoading,
    error: qualifyingQuestionsError
  } = useQuery(ApplicantQualifyingQuestionsContainerApplicantUserCurrentDocument);

  const [saveQualifyingQuestions] = useMutation(ApplicantQualifyingQuestionsContainerApplicantUserUpdateDocument);

  const handleSave = async (values: any) => {
    let termsAndConditions = values?.termsAndConditions || [];

    if (termsAndConditions && termsAndConditions.length > 0) {
      termsAndConditions = termsAndConditions.map((term: string) => {
        return {
          acceptanceOf: term,
          version: 1
        };
      });
    }

    if (qualifyingQuestionsData?.applicantUserCurrent?.termsAndConditions && qualifyingQuestionsData.applicantUserCurrent.termsAndConditions.length > 0) {
      termsAndConditions = qualifyingQuestionsData.applicantUserCurrent.termsAndConditions.map((term) => (term ? { id: term.id } : null));
    }

    try {
      const result = await saveQualifyingQuestions({
        variables: {
          input: {
            id: qualifyingQuestionsData?.applicantUserCurrent?.id,
            applicantUserDetails: {
              ...values,
              termsAndConditions: termsAndConditions
            }
          }
        }
      });
      if (result.data?.applicantUserUpdate?.status.success) {
        message.success('Qualification questions data saved successfully');
        navigate(`/applicant/onboarding/contact-details`);
      } else {
        message.error(`Error saving qualification questions data: ${result.data?.applicantUserUpdate?.status.errorMessage}`);
      }
    } catch (error: any) {
      message.error(`Error saving qualification questions: ${error.message || 'An unexpected error occurred'}`);
    }
  };

  const filteredEntity = entities?.entities?.filter((entity) => entity?.isClient);

  return (
    <ComponentQueryLoader
      error={entitiesError || qualifyingQuestionsError || healthProfessionError}
      loading={entitiesLoading || qualifyingQuestionsLoading}
      hasData={entities && qualifyingQuestionsData?.applicantUserCurrent && healthData}
      hasDataComponent={
        <QualifyingQuestions
          healthProfessionsData={healthData?.healthProfessionsData?.healthProfessions}
          entitiesData={filteredEntity as ApplicantQualifyingQuestionsContainerEntityFieldsFragment[]}
          applicantUserData={qualifyingQuestionsData?.applicantUserCurrent as ApplicantQualifyingQuestionsContainerApplicantUserFieldsFragment}
          onSave={handleSave}
        />
      }
    />
  );
};
